// src/components/HowItWorksSection.jsx
import React from 'react';
import { motion } from 'framer-motion'; // Import motion

const steps = [
    { 
        number: 1,
        title: 'Create Your Account',
        description: "Sign up quickly and securely. We only ask for the essentials to keep our community safe and local."
    },
    {
        number: 2,
        title: "Pick Your Borough & Interests",
        description: "Choose your borough (e.g., Brooklyn, Queens) and select topics you care about, from transit to housing."
    },
    {
        number: 3,
        title: "Join Discussions or Start Your Own",
        description: "Jump into real-time neighborhood chats or create a new room for a specific event or local issue."
    },
];

const HowItWorksSection = () => {
    
    // Define motion variants for the staggered grid entrance
    const container = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15, // Stagger children animations
                delayChildren: 0.2, // Slight delay for the whole grid
            }
        }
    };

    // Define motion variants for individual items (cards)
    const item = {
        hidden: { y: 20, opacity: 0 },
        visible: { y: 0, opacity: 1, transition: { duration: 0.5 } }
    };

    return (
        <div className="how-it-works-container">
            <div className="how-it-works-wrapper">
                
                {/* Apply simple fade-in to title and subtitle */}
                <motion.h2 
                    className="how-it-works-title"
                    initial={{ opacity: 0, y: -10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    How It Works
                </motion.h2>
                <motion.p 
                    className="how-it-works-subtitle"
                    initial={{ opacity: 0, y: -10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                >
                    Get connected to your city in three simple steps.
                </motion.p>

                {/* Apply staggered animation to the grid container */}
                <motion.div 
                    className="how-it-works-grid"
                    variants={container}
                    initial="hidden"
                    // Use whileInView to trigger animation when the component scrolls into view
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }} // Animates only once when 50% visible
                >
                    {steps.map((step) => (
                        <motion.div 
                            key={step.number} 
                            className="how-it-works-card"
                            variants={item} // Apply the staggered entrance
                            whileHover={{ 
                                scale: 1.03, 
                                boxShadow: '0 10px 20px rgba(100, 149, 237, 0.4)' 
                            }}
                            transition={{ duration: 0.3 }}
                        >
                            <div className="how-it-works-number-ring">
                                <span className="how-it-works-number">
                                    {step.number}
                                </span>
                            </div>
                            
                            <h4 className="how-it-works-card-title">
                                {step.title}
                            </h4>
                            <p className="how-it-works-description">
                                {step.description}
                            </p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </div>
    );
};

export default HowItWorksSection;